import React from 'react';
import ReactDOM from 'react-dom';

// eslint-disable-next-line
import Bootstrap from 'bootstrap/dist/css/bootstrap.css'
import Dashboard from './modules/Dashboard/Components'
import 'velocity-animate';
import 'velocity-animate/velocity.ui'

import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'

import { createStore, applyMiddleware, compose } from 'redux'

import { Provider } from 'react-redux'
import appReducer from './redux/reducer'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'

import { ProductTable} from './modules/Products/Components'

import { KitsTable,KitsStoresTable,KitsStoresUpdateLocationTable,KitsProductsTable,KitsProductsUpdateTable} from './modules/Kits/Components'


import { ProductsStocksTable,ProductUpdateStockTable} from './modules/ProductsStocks/Components'

import { OrderVerificationTable} from './modules/Order Verification/Components'
import { NewJoineeTable} from './modules/New Joinee/Components'





import { KitchenStaffsTable,AddEditKitchenStaff} from './modules/Kitchen Staffs/Components'

import { EmployeeDeputeTable,AddEmployeeDepute} from './modules/Employee Depute/Components'

import { EmployeeRehireTable,AddEmployeeRehire} from './modules/Employee Rehire/Components'

import { AssetsTable,AddEditAsset} from './modules/Assets/Components'

import { AssetTypesTable,AddEditAssetType} from './modules/Asset Types/Components'

import { AssetVendorsTable,AddEditAssetVendor} from './modules/Asset Vendors/Components'
import { EquipmentsTable,AddEditEquipment} from './modules/Equipments/Components'

import { AssetLocationsTable,AddEditAssetLocation} from './modules/Asset Locations/Components'

import { EmployeePromotionTable,AddEmployeePromotion} from './modules/Employee Promotion/Components'

import { AttendanceTable,AddEditAttendance} from './modules/Attendance/Components'


import { UsersTable } from './modules/Users/Components'



import { MenuDisabledTicketsTable,UpdateMenuDisabledTicket} from './modules/Menu Disabled Tickets/Components'





import {BrandsTable,AddEditBrand} from './modules/Brands/Components'

import {CategoriesTable,AddEditCategory} from './modules/Categories/Components'
import {MenusTable,AddEditMenu} from './modules/Menus/Components'

import {CitiesTable} from './modules/Cities/Components'

import {AttendanceCyclesTable} from './modules/Attendance Cycles/Components'

import {EmployeePayScalesTable,AddEditEmployeePayScale} from './modules/Employee Pay Scales/Components'

import {EntityTypesTable,AddEditEntityType} from './modules/Entity Types/Components'

import {EntityStatusTable,AddEditEntityStatus} from './modules/Entity Status/Components'


import {PlatformsTable,AddEditPlatforms} from './modules/Platforms/Components'

import {AttendanceSummaryTable} from './modules/Attendance Summary/Components'


import {TeamsTable,AddEmployeeAttrition,AddAttendance} from './modules/Teams/Components'



import {ClustersTable,AddEditCluster} from './modules/Clusters/Components'
import {KitchensTable,AddEditKitchen,ViewKitchenTeamTable} from './modules/Kitchens/Components'
import {StoresTable,AddEditStore,AddEditStoreTiming,StoresTicketsTable,UpdateStoresTicket,StoresTicketsLiveTable,STAgentsTable,AddSTAgentKitchens,AssignAgentStoresTicket} from './modules/Stores/Components'

import {PrivilegesTable,AddEditPrivileges} from './modules/Privileges/Components'

import {EmployeesTable,AddEditEmployee,ViewEmployee,EmployeesAttritionTable,EditEmployeeAttrition,AddEditEmployeeResources} from './modules/Employees/Components'



import {EmployeesMovementTable,AddEmployeeMovement} from './modules/Employees Movement/Components'

import {RolesTable,AddEditRoles} from './modules/Roles/Components'

import {DesignationsTable,AddEditDesignations} from './modules/Designations/Components'

import {DepartmentsTable,AddEditDepartments} from './modules/Departments/Components'

import {DepartmentTeamsTable,AddEditDepartmentTeams} from './modules/Department Teams/Components'

import {CostCentersTable,AddEditCostCenters} from './modules/Cost Centers/Components'
import {WorkLocationsTable,AddEditWorkLocations} from './modules/Work Locations/Components'


import {HRTicketsTable,AddEditHRTicket} from './modules/HR/Components'

import {STReportsTable} from './modules/ST Reports/Components'




import {ReasonsTable,AddEditReasons} from './modules/Reasons/Components'


import Login from './modules/LoginPage/Components'
import { ForgotPassword,ForgotPasswordRequest } from './modules/ForgotPassword/Components'
import PasswordReset from './modules/ResetPassword/Components/PasswordReset'

import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper'
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'
import * as Constants from './common/constants'

const loggerMiddleware = createLogger({
    predicate: (getState, action) => LOGGER_NEEDED
})

const enhancer = compose(
    // Middleware you want to use in development:
    // thunkMiddleware - lets us dispatch() functions
    // loggerMiddleware - neat middleware that logs actions
    // routingMiddleware - to capture dispatched actions created by the action creators
    applyMiddleware(thunkMiddleware, loggerMiddleware),
)

// We need to clean reset the redux state when user logout,
// doing this way will all the composition / child redux state
// will be set to their respective initial state
const rootReducer = (state, action) => {
    if (action.type === 'logout-request') {
        state = undefined
    } else if(action.type === "expiry-token-logout") {
        state = undefined
        state = { user: { expiry_token_message: "Session Expired Please login." } }
    }
    return appReducer(state, action)
}

const persistedState = localStorage.getItem(Constants.HBB_STORE_NAME) ? JSON.parse(localStorage.getItem(Constants.HBB_STORE_NAME)) : {}
const store = createStore(rootReducer, persistedState, enhancer)
// const history = syncHistoryWithStore(store)

store.subscribe(() => {
    localStorage.setItem(Constants.HBB_STORE_NAME, JSON.stringify(store.getState()))
})

const userIsAuthenticated = connectedRouterRedirect({
   // The url to redirect user to if they fail
  redirectPath: '/login',
   // Determine if the user is authenticated or not
  authenticatedSelector: state => state.user.isLogged === true,
  // A nice display name for this check
  wrapperDisplayName: 'UserIsAuthenticated'
})

const locationHelper = locationHelperBuilder({})

const userIsNotAuthenticated = connectedRouterRedirect({
  // This sends the user either to the query param route if we have one, or to the landing page if none is specified and the user is already logged in
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/dashboard',
  // This prevents us from adding the query parameter when we send the user away from the login page
  allowRedirectBack: false,
  // Determine if the user is authenticated or not
  authenticatedSelector: state => state.user.isLogged === false,
  // A nice display name for this check
  wrapperDisplayName: 'UserIsNotAuthenticated'
})

const DashboardChildrenSelection = () => (
    <div>
        <Dashboard>
            <Switch>
                <Route exact path='/dashboard'>
                    <Redirect to='/dashboard/products'/>
                </Route>
                 <Route exact path='/dashboard/products'>
                    <Redirect to='/dashboard/products/list'/>
                </Route>

                
                <Route path='/dashboard/products/list' component={ProductTable}/>

                
                <Route path='/dashboard/kits/list' component={KitsTable}/>
                <Route path='/dashboard/kits/products/list' component={KitsProductsTable}/>
                <Route path='/dashboard/kits/products/update' component={KitsProductsUpdateTable}/>
                <Route path='/dashboard/kits/stores/list' component={KitsStoresTable}/>
                <Route path='/dashboard/kits/stores/updatelocation' component={KitsStoresUpdateLocationTable}/>
                              

                <Route path='/dashboard/products/stocks/list' component={ProductsStocksTable}/>
                <Route path='/dashboard/products/stocks/updatestock' component={ProductUpdateStockTable}/>


                <Route path='/dashboard/orderVerification/list' component={OrderVerificationTable}/>
                
                <Route path='/dashboard/newJoinee/list' component={NewJoineeTable}/>



                

                <Route path='/dashboard/privileges/list' component={PrivilegesTable}/>
                <Route path='/dashboard/privileges/addEdit' component={AddEditPrivileges}/>
  

                <Route path='/dashboard/brands/list' component ={BrandsTable}/>
                <Route path='/dashboard/brands/addEdit' component ={AddEditBrand}/>
                
                <Route path='/dashboard/attendances/list' component ={AttendanceTable}/>
                <Route path='/dashboard/attendances/addEdit' component ={AddEditAttendance}/>

                
                <Route path='/dashboard/categories/list' component ={CategoriesTable}/>
                <Route path='/dashboard/categories/addEdit' component ={AddEditCategory}/>

                
                <Route path='/dashboard/menus/list' component ={MenusTable}/>
                <Route path='/dashboard/menus/addEdit' component ={AddEditMenu}/>                


                
                <Route path='/dashboard/cities/list' component ={CitiesTable}/>

               
                <Route path='/dashboard/attendanceCycles/list' component ={AttendanceCyclesTable}/>

                
                 <Route path='/dashboard/employeePayScales/list' component ={EmployeePayScalesTable}/>
                <Route path='/dashboard/employeePayScales/addEdit' component ={AddEditEmployeePayScale}/>

               
                <Route path='/dashboard/entityTypes/list' component ={EntityTypesTable}/>
                <Route path='/dashboard/entityTypes/addEdit' component ={AddEditEntityType}/>


                
                <Route path='/dashboard/entityStatus/list' component ={EntityStatusTable}/>
                <Route path='/dashboard/entityStatus/addEdit' component ={AddEditEntityStatus}/>


               
                <Route path='/dashboard/platforms/list' component ={PlatformsTable}/>
                <Route path='/dashboard/platforms/addEdit' component ={AddEditPlatforms}/>

                
                <Route path='/dashboard/attendances/summary' component ={AttendanceSummaryTable}/>



                <Route path='/dashboard/clusters/list' component ={ClustersTable}/>
                <Route path='/dashboard/clusters/addEdit' component ={AddEditCluster}/>
                

                <Route path='/dashboard/kitchenStaffs/list' component ={KitchenStaffsTable}/>
                <Route path='/dashboard/kitchenStaffs/addEdit' component ={AddEditKitchenStaff}/>


                
                <Route path='/dashboard/employeeDeputedLocations/list' component ={EmployeeDeputeTable}/>
                <Route path='/dashboard/employeeDeputedLocations/add' component ={AddEmployeeDepute}/>

                
                 <Route path='/dashboard/employeeRehire/list' component ={EmployeeRehireTable}/>
                <Route path='/dashboard/employeeRehire/add' component ={AddEmployeeRehire}/>

                
                <Route path='/dashboard/employeePromotion/list' component ={EmployeePromotionTable}/>
                <Route path='/dashboard/employeePromotion/add' component ={AddEmployeePromotion}/>




                
                <Route path='/dashboard/users/list' component ={UsersTable}/>

                
                <Route path='/dashboard/menuDisabledTickets/list' component ={MenuDisabledTicketsTable}/>
                <Route path='/dashboard/menuDisabledTickets/update' component ={UpdateMenuDisabledTicket}/>


                
                 <Route path='/dashboard/kitchens/list' component ={KitchensTable}/>
                <Route path='/dashboard/kitchens/addEdit' component ={AddEditKitchen}/>                
                <Route path='/dashboard/kitchens/viewTeam' component ={ViewKitchenTeamTable}/>
                
                
                <Route path='/dashboard/stores/list' component ={StoresTable}/>
                <Route path='/dashboard/stores/addEditTiming' component={AddEditStoreTiming}/>
                <Route path='/dashboard/storestickets/list' component ={StoresTicketsTable}/>
                <Route path='/dashboard/storestickets/edit' component ={UpdateStoresTicket}/>
                <Route path='/dashboard/storestickets/assignAgent' component ={AssignAgentStoresTicket}/>
                <Route path='/dashboard/storestickets/live' component ={StoresTicketsLiveTable}/>
                <Route path='/dashboard/storestickets/summary' component ={STReportsTable}/>
                <Route path='/dashboard/stores/addEdit' component={AddEditStore}/> 


                <Route path='/dashboard/storestickets/agents/list' component ={STAgentsTable}/>
                <Route path='/dashboard/storestickets/agents/add' component ={AddSTAgentKitchens}/>


               
                <Route path='/dashboard/employees/list' component ={EmployeesTable}/>
                <Route path='/dashboard/employees/addEdit' component ={AddEditEmployee}/>
                <Route path='/dashboard/employees/addAttrition' component ={AddEmployeeAttrition}/>
                <Route path='/dashboard/employees/view' component ={ViewEmployee}/> 
                <Route path='/dashboard/employee/resources' component ={AddEditEmployeeResources}/> 


                
                <Route path='/dashboard/employeeMovements/list' component ={EmployeesMovementTable}/> 
                <Route path='/dashboard/employeeMovements/add' component ={AddEmployeeMovement}/> 

                <Route path='/dashboard/employeesAttrition/list' component ={EmployeesAttritionTable}/>  
                <Route path='/dashboard/employeesAttrition/edit' component ={EditEmployeeAttrition}/>

               
                <Route path='/dashboard/hr/hrtickets/list' component ={HRTicketsTable}/>
                <Route path='/dashboard/hr/hrtickets/addEdit' component ={AddEditHRTicket}/>



                
                 <Route path='/dashboard/employees/teams/list' component ={TeamsTable}/> 
                <Route path='/dashboard/employees/teams/addAttendance' component ={AddAttendance}/> 


               
                <Route path='/dashboard/roles/list' component ={RolesTable}/>
                <Route path='/dashboard/roles/addEdit' component ={AddEditRoles}/>

                
                 <Route path='/dashboard/resetpassword' component={PasswordReset}/>

                
                <Route path='/dashboard/designations/list' component ={DesignationsTable}/>
                <Route path='/dashboard/designations/addEdit' component ={AddEditDesignations}/>

                
                <Route path='/dashboard/departments/list' component ={DepartmentsTable}/>
                <Route path='/dashboard/departments/addEdit' component ={AddEditDepartments}/>


                <Route path='/dashboard/assets/list' component ={AssetsTable}/>
                <Route path='/dashboard/assets/addEdit' component ={AddEditAsset}/>



                <Route path='/dashboard/equipmentCategory/list' component ={AssetTypesTable}/>
                <Route path='/dashboard/equipmentCategory/addEdit' component ={AddEditAssetType}/>


                <Route path='/dashboard/vendors/list' component ={AssetVendorsTable}/>
                <Route path='/dashboard/vendors/addEdit' component ={AddEditAssetVendor}/>

                <Route path='/dashboard/equipments/list' component ={EquipmentsTable}/>
                <Route path='/dashboard/equipments/addEdit' component ={AddEditEquipment}/>


                <Route path='/dashboard/assetLocations/list' component ={AssetLocationsTable}/>
                <Route path='/dashboard/assetLocations/addEdit' component ={AddEditAssetLocation}/>



                
                <Route path='/dashboard/department/teams/list' component ={DepartmentTeamsTable}/>
                <Route path='/dashboard/department/teams/addEdit' component ={AddEditDepartmentTeams}/>

               
                <Route path='/dashboard/workLocations/list' component ={WorkLocationsTable}/>
                <Route path='/dashboard/workLocations/addEdit' component ={AddEditWorkLocations}/>

                
                <Route path='/dashboard/costCenters/list' component ={CostCentersTable}/>
                <Route path='/dashboard/costCenters/addEdit' component ={AddEditCostCenters}/>

               
                <Route path='/dashboard/reasons/list' component ={ReasonsTable}/>
                <Route path='/dashboard/reasons/addEdit' component ={AddEditReasons}/>

                
            </Switch>
        </Dashboard>
    </div>
)

ReactDOM.render((
    <div>
        <Provider store={store}>
            <Router>
                <div style={{ backgroundColor: '#f0f0f0', position: 'fixed', height: '100%', width: '100%' }}>
                    <Switch>
                        <Route exact path="/">
                            <Redirect to='/login'/>
                        </Route>
                        <Route path='/login' component={userIsNotAuthenticated(Login)}/>
                        <Route path='/dashboard' component={userIsAuthenticated(DashboardChildrenSelection)}/>
                         <Route path='/forgotpasswordrequest' component={ForgotPasswordRequest}/>
                        <Route path='/resetpassword/:token' component={ForgotPassword}/>
                        {/*<Route path='/registration' component={Registration}/>
                        <Route path='/invoice/:id' component={InvoiceCreation}/>
                        <Route path='/welcome/:productname' component={LandingPageLayout}/>
                        <Route path='/about' component={About}/>
                        <Route path='/home' component={Home}/>
                        <Route path='/sellercreation' component={SellerCreation}/>
                        <Route path='/signup' component={SignUp}/> */}
                        <Route path='*'>
                            <Redirect to='/login'/>
                        </Route>
                    </Switch>
                </div>
            </Router>
        </Provider>
    </div>), document.getElementById('root'))
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js